import { sanitizeStoryblokRichSnippetContent } from "./storyblok-rich-snippets"
import { toJsonLdString } from "./jsonld"

/** Cat-route policy only. Keep other graph nodes and Product details intact. */
export function sanitizeCatReviewSnippet(content: string): string | null {
  const sanitized = sanitizeStoryblokRichSnippetContent(content)

  if (sanitized === null) {
    return null
  }

  const schema: unknown = JSON.parse(sanitized)
  const clean = (node: unknown): void => {
    if (Array.isArray(node)) {
      node.forEach(clean)

      return
    }

    if (typeof node !== "object" || node === null) {
      return
    }

    const record = node as Record<string, unknown>
    const types = Array.isArray(record["@type"])
      ? record["@type"]
      : [record["@type"]]

    if (types.includes("Product")) {
      delete record.aggregateRating
      delete record.review
    }

    Object.values(record).forEach(clean)
  }

  clean(schema)

  return toJsonLdString(schema)
}
